let help_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'helps/categories', name: 'helps.categories-list', component: () => import('./pages/categories/Index.vue') },
      { path: 'helps/categories/create', name: 'helps.categories-create', component: () => import('./pages/categories/Create.vue') },
      { path: 'helps/categories/:id/edit', name: 'helps.categories-edit', component: () => import('./pages/categories/Edit.vue') },
      { path: 'helps', name: 'helps.list', component: () => import('./pages/Index.vue') },
      { path: 'helps/create', name: 'helps.create', component: () => import('./pages/Create.vue') },
      { path: 'helps/:id/edit', name: 'helps.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default help_routes;
